import * as React from "react"
import { journeys } from "config/journeys"
import Footer from "components/Footer"
import JourneyPage from "components/start/JourneyPage"
import Document from "components/Document"
import Navbar from "components/Navbar"
import { GetStartedType } from "components/Navbar/GetStartedButton"
import SideNav from "components/SideNav"
import { brand } from "config/brand"
import PageWrapper from "components/PageWrapper"
import imgPurchasingAHomeLandscape from "images/start/purchasing-a-home-landscape.jpg"

const BetterRate: React.FC = () => {
  return (
    <Document
      description={`Get started on your mortgage journey with ${brand.name}.`}
      pageClass="JourneyPage"
      pageId="journeyPage"
      thumbnail={imgPurchasingAHomeLandscape}
      title="Start your Mortgage Journey"
    >
      <Navbar
        getStartedType={GetStartedType.ON_SCROLL}
        startTransparent={true}
      />
      <SideNav />
      <PageWrapper>
        <JourneyPage
          journey={journeys.refinance.pages["better-rate"]}
          continueUrl="/preapprovals/refinance?journey=better-rate"
          transactionType="Refinance"
        />
        <Footer loanType="refinance" />
      </PageWrapper>
    </Document>
  )
}

export default BetterRate
